/**
 * Split per surface so domestic and international can ramp independently:
 * a `test` on one shows the revamp for that surface only, a `test` on both shows it everywhere.
 */
/** Pre-split override already handed to QA: flips both surfaces at once. */
export const SRP_REVAMP_LEGACY_COOKIE = 'srp_revamp_dt'

export const SRP_REVAMP_EXPERIMENTS = {
  dom: {
    experimentName: 'dt_srp_revamp_dom_v2',
    cookieName: 'dt_srp_revamp_dom_v2',
    experimentParameter: 'variant',
    controlVariant: 'control',
    testVariant: 'test',
  },
  intl: {
    experimentName: 'dt_srp_revamp_intl_v2',
    cookieName: 'dt_srp_revamp_intl_v2',
    experimentParameter: 'variant',
    controlVariant: 'control',
    testVariant: 'test',
  },
} as const
